// extracted by mini-css-extract-plugin
module.exports = {"heading":"PrivacyPolicyPage_heading__3V6nJ","content":"PrivacyPolicyPage_content__1Fymn"};